export const ENDPOINTS_BILLING_ADMIN = {
  LOOKUP: "/api/admin/billing/lookup",
  GRANT: "/api/admin/billing/grant-premium",
};
